var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/.deno/lodash@4.17.21/~/lodash/_getPrototype.js
// module id = 280
// module chunks = 0